export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center pt-16 overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/50 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/40 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-screen-2xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-4">
              <i className="ri-fire-line text-base"></i>
              <span className="whitespace-nowrap">24小时不停歇 · 吃瓜第一线</span>
            </div>

            <h1
              className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              今日大瓜
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-2">
                全网最新娱乐吃瓜资讯平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-light mb-4 max-w-xl mx-auto lg:mx-0">
              汇聚娱乐圈最热门吃瓜大瓜，不放过每一个精彩瞬间
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              今日大瓜网专注整合娱乐吃瓜热点与吃瓜合集内容，覆盖影视、综艺、明星动态等多个维度。
              每日人工甄选最新吃瓜资讯，让你不错过任何一个值得关注的娱乐大瓜。
              本站采用多源交叉核验机制，确保每一条吃瓜资讯来源可追溯、内容经得起推敲。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="whitespace-nowrap">今日已更新 37 条</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-eye-line text-primary-500"></i>
                <span className="whitespace-nowrap">日均浏览 50w+</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-accent-500"></i>
                <span className="whitespace-nowrap">多源核验 · 靠谱吃瓜</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-fire-line"></i>
                <span>查看今日热度榜</span>
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full font-medium text-base whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors border border-background-200"
              >
                <i className="ri-timer-flash-line"></i>
                <span>最新吃瓜快讯</span>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20representing%20entertainment%20news%20and%20celebrity%20gossip%20culture%2C%20warm%20coral%20and%20amber%20tones%2C%20abstract%20geometric%20shapes%20blending%20with%20newspaper%20and%20cinema%20elements%2C%20modern%20editorial%20design%20aesthetic%2C%20clean%20composition%20with%20dynamic%20energy%2C%20soft%20gradients%2C%20artistic%20collage%20style%2C%20subtle%20spotlight%20motifs&width=1000&height=750&seq=hero-main-visual-2026&orientation=landscape"
                alt="今日大瓜娱乐吃瓜资讯平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}